export default axios => ({
  get(sessionId, payload) {
    return axios.get(`session/${sessionId}/questionnaire`, payload);
  },
  compendium(type, payload) {
    return axios.get(`compendium/${type}`, payload);
  },
  post(session_id, questionnaire_id, payload) {
    return axios.post(`/session/${session_id}/questionnaire`, payload);
  },
  update(session_id, questionnaire_id, payload) {
    return axios.patch(`/session/${session_id}/questionnaire/${questionnaire_id}`, payload);
  },
  send (type, session_id, questionnaire_id, payload) {
    if(type == 'post') return axios.post(`/session/${session_id}/questionnaire`, payload)
    if(type == 'update') return axios.patch(`/session/${session_id}/questionnaire/${questionnaire_id}`, payload);
  }
})
